export enum Type {
  VIDEO_EDIT_PREPARE_REQUEST = 'app/video-edit/VIDEO_EDIT_PREPARE_REQUEST',
  VIDEO_EDIT_PREPARE_SUCCESS = 'app/video-edit/VIDEO_EDIT_PREPARE_SUCCESS',
  VIDEO_EDIT_PREPARE_FAILURE = 'app/video-edit/VIDEO_EDIT_PREPARE_FAILURE',
  VIDEO_EDIT_CLEAR = 'app/video-edit/VIDEO_EDIT_CLEAR',
}
